import { StateCreator } from "zustand";
import { ReportSliceType } from "./report.type";

const createReportSlice: StateCreator<ReportSliceType> = (set) => ({
  incident: null,
  facilitiesReportData: null,
  setIncident: (incident: any) =>
    set(() => {
      return { incident };
    }),
  setFacilitiesReportData: (facilitiesReportData: any) =>
    set(() => {
      return { facilitiesReportData };
    }),
});

export default createReportSlice;
